import React from "react";

/**
 * @param {Object} props
 * @param {string[]} props.existingAttachments
 * @returns {React.JSX.Element}
 */
export default function Attachments({ existingAttachments }) {
  return (
    <div className="panel-body">
      <ul className="list-unstyled">
        {existingAttachments.length === 0 ? (
          <li>No attachments found to display</li>
        ) : (
          existingAttachments.map((attachment, index) => (
            <li key={index}>
              <a href={`attachment/${attachment}`}>{attachment}</a>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
